import React, { useState, useEffect } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { Variables } from "../../Variables1/Variables";
import validator from "validator";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import {
    Row,
    Col,
    Image,
    Form,
    Button,
    Spinner,
    FormCheck,
} from "react-bootstrap";
import Multiselect from "multiselect-react-dropdown";
import { Card } from "react-bootstrap";
import { Link } from "react-router-dom";
import CustomSnipper from "../../components/customSnipper";
import Util from "../../Classes/Util";
import axios from "axios";

const ManageSlide = () => {
    const SlideRouteId = useParams();
    const navigate = useNavigate();
    const [Permissions, setPermissions] = useState(
        Util.decrypt(localStorage.getItem("rpmRRTLx12"))
    );

    const [slideId, setSlideId] = useState(
        Number(SlideRouteId.SlideRouteId) || 0
    );

    const [loader, setLoader] = useState(false);
    const [buttonLoader, setButtonLoader] = useState(false);

    const [slideExist, setSlideExist] = useState(null);
    const [slideDetails, setSlideDetails] = useState({
        SlideId: 0,
        Title: "",
        Image: "",
        Subtitle: "",
        isPublished: true,
    });
    const [image, setImage] = useState("");
    const [imageToDb, setImageToDb] = useState("");

    // get Slide details
    const GetSlideDetails = async () => {
        let response = await fetch(
            Variables.API_URL + "Slider/GetSlideDetails/" + slideId,
            {
                method: "GET",
                headers: {
                    Accept: "application/json",
                    "Content-Type": "application/json",
                },
            }
        );
        let result = await response.json();
        if (response.status === 200) {
            setSlideDetails({
                SlideId: result.SlideId,
                Title: result.Title,
                Subtitle: result.Subtitle,
                Image: result.Image,
                isPublished: result.IsPublished
            });
            console.log("slideDetails",slideDetails);
            setSlideExist(true);
        } else {
            setSlideExist(false);
        }
    };

    // handle Inputs
    const handleInputs = (e) => {
        const { name, value } = e.target;
        var element;
        if (value === "" || value === "0") {
            element = document.getElementById(name);
            element.classList.add("is-invalid");
        } else {
            element = document.getElementById(name);
            element.classList.remove("is-invalid");
        }
        setSlideDetails((prevState) => ({
            ...prevState,
            [name]: value,
        }));
    };

    // Set Image
    const SetImage = (e) => {
        var x = e.target.files[0];
        let reader = new FileReader();
        reader.onload = function (e) {
            if (
                e.target.result.indexOf("png") >= 0 ||
                e.target.result.indexOf("jpeg") >= 0 ||
                e.target.result.indexOf("jpg") >= 0
            ) {
                setImageToDb(x);
                setImage(e.target.result);
            } else {
                toast.error("File type error", {
                    position: "top-right",
                    autoClose: 5000,
                    hideProgressBar: false,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true,
                    progress: undefined,
                });
            }
        };
        reader.readAsDataURL(e.target.files[0]);
        var element = document.getElementById("ImageUrl");
        element.classList.remove("is-invalid");
    };
    // Handle IsPublished
    const HandleIsPublished = () => {
        console.log(slideDetails);
        if (slideDetails.isPublished === true) {
            setSlideDetails((prevState) => ({
                ...prevState,
                isPublished: false,
            }));
        } else {
            setSlideDetails((prevState) => ({
                ...prevState,
                isPublished: true,
            }));
        }
    };
    // Check input validity
    function IsValid() {
        var hasError = false;
        var element;
        if (slideDetails.Title === null || slideDetails.Title === "") {
            element = document.getElementById("Title");
            element.classList.add("is-invalid");
            element.focus();
            hasError = true;
        }
        if (hasError === true) {
            return false;
        } else {
            return true;
        }
    }

    const AddNewSlide = async () => {
        setButtonLoader(true);
        let response = await fetch(Variables.API_URL + "Slider/AddNewSlide", {
            method: "POST",
            headers: {
                Accept: "application/json",
                "Content-Type": "application/json",
            },
            body: JSON.stringify({
                SlideId: slideDetails.SlideId,
                Title: slideDetails.Title,
                Image: "",
                Subtitle: slideDetails.Subtitle,
                isPublished: slideDetails.isPublished
            }),
        });
        let result = await response.json();
        if (response.status === 200) {
            toast.success("Slide Added Successfully", {
                position: "top-right",
                autoClose: 5000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
            });

            if (imageToDb != "") {
                const formData = new FormData();
                formData.append("Image", imageToDb);
                formData.append("SlideId", result);

                const resImage = await axios.post(
                    Variables.API_URL + "Slider/UploadSlideMedia",
                    formData
                );
            }

            setTimeout(() => {
                navigate("/Slides");
            }, 1000);
        } else {
            toast.error(result, {
                position: "top-right",
                autoClose: 5000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
            });
        }
        setButtonLoader(false);
    };

    // Update Slide
    const UpdateSlide = async () => {
        setButtonLoader(true);
        let response = await fetch(Variables.API_URL + "Slider/UpdateSlide", {
            method: "POST",
            headers: {
                Accept: "application/json",
                "Content-Type": "application/json",
            },
            body: JSON.stringify({
                slideId: slideDetails.SlideId,
                Title: slideDetails.Title,
                Image: "",
                Subtitle: slideDetails.Subtitle,
                isPublished: slideDetails.isPublished
            }),
        });
        let result = await response.json();
        if (response.status === 200) {
            toast.success(result, {
                position: "top-right",
                autoClose: 5000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
            });

            if (imageToDb != "") {

                const formData = new FormData();
                formData.append("Image", imageToDb);
                formData.append("SlideId", slideId);

                const resImage = await axios.post(
                    Variables.API_URL + "Slider/UploadSlideMedia",
                    formData
                );
            }
            setTimeout(() => {
                navigate("/Slides");
            }, 1000);
        } else {
            toast.error(result, {
                position: "top-right",
                autoClose: 5000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
            });
        }
        setButtonLoader(false);
    };
    const HandleSumbit = async () => {
        var isValid = IsValid();
        if (isValid) {
            if (slideId === 0) {
                AddNewSlide();
            }
            else {
                UpdateSlide();
            }
        } else {
            toast.error("Please Fill All Required Fields", {
                position: "top-right",
                autoClose: 5000,
                hideProgressBar: false,
                closeOnClick: true,
                draggable: true,
                progress: undefined,
            });
        }
    };

    useEffect(() => {
        if (slideId != 0) {
            GetSlideDetails();
        }
    }, []);

    return (
        <div>
            <Row>
                <Col sm="12">
                    <Card>
                        <Card.Header className="d-flex justify-content-between">
                            <div className="header-title">
                                <h4 className="card-title">
                                    {slideId === 0
                                        ? "Add New Slide"
                                        : "Manage Slide --> " + slideDetails.Title}
                                </h4>
                            </div>
                        </Card.Header>
                        <Card.Body>
                            {loader === true ? (
                                <CustomSnipper />
                            ) : (
                                <div>
                                    <Row>
                                        <Form.Group className="col-md-6 form-group">
                                            <Form.Label htmlFor="fname">Title :</Form.Label>
                                            <Form.Control
                                                id="Title"
                                                name="Title"
                                                placeholder="Title"
                                                type="text"
                                                value={slideDetails.Title}
                                                onChange={handleInputs}
                                            />
                                        </Form.Group>

                                        <Form.Group className="col-md-6 form-group">
                                            <Form.Label htmlFor="fname">Subtitle :</Form.Label>
                                            <Form.Control
                                                id="Subtitle"
                                                name="Subtitle"
                                                placeholder="Subtitle"
                                                type="text"
                                                value={slideDetails.Subtitle}
                                                onChange={handleInputs}
                                            />
                                        </Form.Group>
                                        <Form.Group className="col-md-3 form-group">
                                            <Form.Label htmlFor="fname">.</Form.Label>
                                            <Form.Check className="mb-3 form-check">
                                                <FormCheck.Input
                                                    type="checkbox"
                                                    className=""
                                                    id="Published"
                                                    checked={slideDetails.isPublished}
                                                    onChange={(e) => HandleIsPublished()}
                                                />
                                                <FormCheck.Label className="" htmlFor="exampleCheck1">
                                                    IsPublished
                                                </FormCheck.Label>
                                            </Form.Check>
                                        </Form.Group>



                                        <Form.Group className="col-lg-6 col-md-12 col-sm-12 form-group">
                                            <Row>
                                                <Form.Group>
                                                    <Form.Label className="custom-file-input">
                                                        Choose Image
                                                    </Form.Label>
                                                    <Form.Control
                                                        id="ImageUrl"
                                                        name="ImageUrl"
                                                        placeholder="Image"
                                                        type="file"
                                                        accept="image/*"
                                                        onChange={SetImage}
                                                    />
                                                </Form.Group>
                                            </Row>
                                            <Row>
                                                <Col className="allignCenter">
                                                    {image !== "" ? (
                                                        <div>
                                                            <img
                                                                src={image}
                                                                className="w-100 shadow-1-strong rounded mb-4 img-200 image-log sqaureImage"
                                                                alt="Boat on Calm Water"
                                                            />
                                                        </div>
                                                    ) : slideDetails.Image !== "" &&
                                                        slideDetails.Image !== null ? (
                                                        <div>
                                                            <img
                                                                src={
                                                                    Variables.imagePath + slideDetails.Image
                                                                }
                                                                className="w-100 shadow-1-strong rounded mb-4 img-200 image-log sqaureImage"
                                                                alt="Boat on Calm Water"
                                                            />
                                                        </div>
                                                    ) : (
                                                        ""
                                                    )}
                                                </Col>
                                            </Row>
                                        </Form.Group>
                                    </Row>
                                </div>
                            )}
                            <hr />

                            <div className="float-right">
                                <Button
                                    type="button"
                                    variant="btn btn-primary"
                                    onClick={HandleSumbit}
                                >
                                    {buttonLoader == true ? (
                                        <Spinner animation="border" variant="light" role="status">
                                            <span className="visually-hidden">Loading...</span>
                                        </Spinner>
                                    ) : (
                                        "Submit"
                                    )}
                                </Button>{" "}
                                <Button
                                    type="button"
                                    variant="btn btn-secondary"
                                    onClick={() => navigate("/Slides")}
                                >
                                    Cancel
                                </Button>
                            </div>
                        </Card.Body>
                    </Card>
                </Col>
            </Row>
            <ToastContainer
                position="top-right"
                autoClose={5000}
                hideProgressBar={false}
                newestOnTop={true}
                closeOnClick
                rtl={false}
                pauseOnFocusLoss
                draggable
                pauseOnHover
            />
        </div>
    );

}
export default ManageSlide;